module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features address-info sr-info"
  }, [_c('div', {
    staticClass: "address-container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._m(0), _c('div', {
    staticClass: "feature"
  }, [_c('p'), _c('div', {
    staticClass: "big-number",
    attrs: {
      "id": "trx_paid"
    }
  }, [_vm._v("0.25%")]), _c('div', {
    staticClass: "feature-helvetica"
  }, [_vm._v("From your referral's mining rewards. Up to 0.5% when applying to our Custom Referral Code program")]), _c('p'), _c('div', {
    staticClass: "mt-10"
  }, [_vm._m(1), _c('div', {
    staticClass: "flex jcc aic"
  }, [_c('div', {
    staticClass: "get-referral-container"
  }, [_c('div', {
    staticClass: "field coin-dropdown mt-20"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "dropdown",
    class: {
      'is-active': _vm.showDropdown
    }
  }, [_c('div', {
    staticClass: "dropdown-trigger",
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('button', {
    staticClass: "button dropdown-button",
    attrs: {
      "aria-haspopup": "true",
      "aria-controls": "dropdown-menu2"
    }
  }, [_c('span', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.selectedCoin || !_vm.selectedCoin.symbol || _vm.showDropdown),
      expression: "!selectedCoin || !selectedCoin.symbol || showDropdown"
    }],
    attrs: {
      "id": "search-coin"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coinFilter),
      expression: "coinFilter"
    }],
    ref: "inputCoin",
    attrs: {
      "id": "search-coin-input",
      "type": "text",
      "placeholder": "Type to filter"
    },
    domProps: {
      "value": (_vm.coinFilter)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.selectFirstElement.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coinFilter = $event.target.value
      }
    }
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedCoin && _vm.selectedCoin.symbol && !_vm.showDropdown),
      expression: "selectedCoin && selectedCoin.symbol && !showDropdown"
    }],
    attrs: {
      "id": "selected-coin"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.selectedCoin.logo,
      "alt": "Image"
    }
  }), _c('strong', [_vm._v(_vm._s(_vm.selectedCoin.name) + " ")]), _c('small', [_vm._v(_vm._s(_vm.selectedCoin.symbol))])])]), _vm._m(2)])]), _c('div', {
    staticClass: "dropdown-menu bg-white",
    attrs: {
      "id": "dropdown-menu2",
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "dropdown-content",
    attrs: {
      "id": "dropdown-list"
    }
  }, _vm._l((_vm.shadowList), function(o) {
    return _c('div', {
      staticClass: "dropdown-item",
      attrs: {
        "data-search": o.name + ' ' + o.symbol + ' ' + o.network,
        "data-symbol": o.symbol,
        "data-name": o.name,
        "data-logo": o.logo,
        "this-content": "this-content"
      },
      on: {
        "click": function($event) {
          return _vm.selectCoin(o)
        }
      }
    }, [_c('div', {
      staticClass: "box"
    }, [_c('article', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('figure', {
      staticClass: "image is-24x24"
    }, [_c('img', {
      attrs: {
        "src": o.logo,
        "alt": "Image"
      }
    })])]), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(o.name) + " ")]), _c('small', [_vm._v(_vm._s(o.symbol) + " ")])]), _c('p', _vm._l((o.chains), function(p) {
      return _c('span', {
        staticClass: "tag mr-1 is-light"
      }, [_vm._v(_vm._s(p.network) + "   ")])
    }), 0)])])])])])
  }), 0)])])])]), _c('div', {
    staticClass: "field has-addons flex-1 mt-20 mb-0"
  }, [_c('div', {
    staticClass: "control flex-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "input input-address",
    class: {
      'is-danger': _vm.errorAddressMessage
    },
    attrs: {
      "id": "miningAddress",
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.findAddress.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control",
    attrs: {
      "id": "find_address"
    }
  }, [_c('a', {
    staticClass: "button is-success",
    class: {
      'disabled-button': _vm.disableInput
    },
    attrs: {
      "disabled": _vm.isFindingAddress || _vm.disableInput
    },
    on: {
      "click": _vm.findAddress
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _c('div', [(_vm.errorAddressMessage) ? _c('p', {
    staticClass: "help help-small notif-danger"
  }, [_vm._v(_vm._s(_vm.errorAddressMessage))]) : _vm._e(), (_vm.selectedCoin && _vm.selectedCoin.regex_memo) ? _c('p', {
    staticClass: "help info-mining-address-memo"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _c('span', [_vm._v("   ")]), _c('u', [_vm._v("If you are mining to an exchange")]), _c('span', [_vm._v(" you must set your Memo or Payment Tag after your address, like this: ")]), _c('strong', {
    staticClass: "bg-warning"
  }, [_vm._v("YOUR_ADDRESS:YOUR_PAYMENT_TAG")])]) : _vm._e(), (_vm.selectedCoin && _vm.selectedCoin.symbol === 'XRP') ? _c('p', {
    staticClass: "help info-mining-address-XRP"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _c('span', [_vm._v("   If you’ve just generated your XRP address in your wallet, ensure it is activated by transferring at least 1 XRP to it before your first mining payout.")])]) : _vm._e()]), (_vm.referralCode) ? _c('div', {
    staticClass: "mt-20"
  }, [_c('div', {
    staticClass: "text-white-on-dark"
  }, [_c('span', [_vm._v("Your ")]), (_vm.hasCustomCode) ? _c('b', [_vm._v("Custom ")]) : _vm._e(), _c('span', [_vm._v("Referral code is:")])]), _c('div', {
    staticClass: "referral-code hint--right text-white-on-dark",
    attrs: {
      "id": "referral_code",
      "aria-label": "Copy"
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.referralCode)
      }
    }
  }, [_vm._v(_vm._s(_vm.referralCode))]), _c('div'), _c('div', {
    staticClass: "referral-link hint--right text-white-on-dark",
    attrs: {
      "id": "referral_link",
      "aria-label": "Copy"
    },
    on: {
      "click": function($event) {
        return _vm.copyToClipboard(_vm.referralLink)
      }
    }
  }, [_vm._v(_vm._s(_vm.referralLink))])]) : _vm._e(), (_vm.referralCode) ? _c('div', {
    staticClass: "mt-20"
  }, [_c('div', {
    staticClass: "is-flex jcc aic"
  }, [_c('div', {
    staticClass: "button-stats-container"
  }, [_c('a', {
    staticClass: "button button-stats is-info",
    attrs: {
      "href": '/address/' + _vm.address + '?coin=' + _vm.selectedCoin.symbol,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "mr-5"
  }, [_vm._v("See your stats")]), _c('i', {
    staticClass: "fa fa-line-chart"
  })])])])]) : _vm._e()])])]), _c('br'), _c('p', {
    staticClass: "mb-10"
  }, [_vm._v("Your referral must add your referral code after the worker name (separated by a \"#\" symbol) and restart the worker!")]), _c('div', {
    staticClass: "miner-pool"
  }, [_c('span', {
    staticClass: "hint--top pointable",
    attrs: {
      "aria-label": "The asset symbol"
    }
  }, [_vm._v(_vm._s(_vm.coin))]), _c('b', [_vm._v(":")]), _c('span', {
    staticClass: "hint--top pointable",
    attrs: {
      "aria-label": 'Their ' + _vm.coin + ' address'
    }
  }, [_vm._v("Address")]), _c('b', [_vm._v(".")]), _c('span', {
    staticClass: "hint--top pointable",
    attrs: {
      "aria-label": "Their worker name!"
    }
  }, [_vm._v("Worker")]), _c('b', [_vm._v("#")]), _c('span', {
    staticClass: "hint--top pointable memo-",
    attrs: {
      "aria-label": "Your Referral code!"
    }
  }, [_vm._v(_vm._s(_vm.referralCode || 'referral-code'))])]), _c('br'), _vm._m(3), _vm._m(4)])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "feature feature-helvetica"
  }, [_c('div', [_c('ul', [_vm._m(5), _c('li', {
    staticClass: "ref-code-toggle"
  }, [_c('b', {
    staticClass: "fs-13"
  }, [_vm._v("When you mine  ")]), _c('div', {
    staticClass: "buttons has-addons"
  }, [_c('button', {
    staticClass: "button is-small",
    class: {
      'is-selected is-info': !_vm.withRefCode
    },
    on: {
      "click": function($event) {
        return _vm.changeUsingCode(false)
      }
    }
  }, [_vm._v("without")]), _c('button', {
    staticClass: "button is-small",
    class: {
      'is-selected is-info': _vm.withRefCode
    },
    on: {
      "click": function($event) {
        return _vm.changeUsingCode(true)
      }
    }
  }, [_vm._v("with")])]), _c('b', {
    staticClass: "fs-13"
  }, [_vm._v("a referral code")])]), _c('li', [(_vm.withRefCode) ? _c('p', {
    staticClass: "mt-10"
  }, [_vm._v("The platform fee is reduced to 0.75% and you earn 99.25% of your mining rewards.")]) : _c('p', {
    staticClass: "mt-10"
  }, [_vm._v("The platform fee stays at 1% and you earn 99% of your mining rewards.")]), _c('referral-image', {
    attrs: {
      "withRefCode": _vm.withRefCode,
      "tier": _vm.baseTier && _vm.baseTier.name ? _vm.baseTier : _vm.defaultTier,
      "widthFee": _vm.withRefCode ? 15 : null,
      "widthMiner": _vm.withRefCode ? 85 : null
    }
  })], 1), _vm._m(6), _c('li', [_vm._m(7), _c('referral-image', {
    attrs: {
      "showDetail": true,
      "tier": _vm.baseTier && _vm.baseTier.name ? _vm.baseTier : _vm.defaultTier,
      "widthFee": 15,
      "widthMiner": 85
    }
  })], 1)])])])])]), _c('div', {
    staticClass: "columns",
    attrs: {
      "id": "content-creator"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('hr'), _c('div', {
    staticClass: "feature feature-helvetica has-text-left"
  }, [_vm._m(8), _c('div', {
    staticClass: "columns is-multiline"
  }, [_vm._m(9), _c('div', {
    staticClass: "column is-two-thirds"
  }, [_c('tab-tiers', {
    attrs: {
      "selectedTab": _vm.selectedTier,
      "listOfTabs": _vm.tiers
    },
    on: {
      "selected": _vm.changeTier,
      "click": _vm.changeTier
    }
  }), _c('div', {
    staticClass: "mt-10 referral-image-container"
  }, [_c('referral-image', {
    staticClass: "referral-image-cc",
    attrs: {
      "showDetail": true,
      "tier": _vm.currentTier && _vm.currentTier.name ? _vm.currentTier : _vm.defaultTier,
      "type": "contentCreator"
    }
  })], 1), (_vm.currentTier) ? _c('div', {
    staticClass: "p-10 mb-30 mt-10 has-text-centered"
  }, [(_vm.selectedTier === 0) ? _c('div', {
    staticClass: "mb-10"
  }, [_c('b', {
    staticClass: "fs-15"
  }, [_vm._v("The base tier gets you the same rewards as a normal referral code.")])]) : _c('div', {
    staticClass: "mb-10"
  }, [_c('div', {
    staticClass: "fs-15"
  }, [_c('b', {
    staticClass: "has-text-weight-bold",
    staticStyle: {
      "color": "#66e093"
    }
  }, [_vm._v(_vm._s(_vm.currentTier.minimum_active) + " or more")]), _c('b', [_vm._v(" active miners using your custom referral code are required")])]), _c('div', {
    staticClass: "mt-5"
  }, [_c('span', [_vm._v("You get an aditional ")]), _c('b', [_vm._v(_vm._s((+_vm.currentTier.owner_percentage - +_vm.baseTier.owner_percentage).toFixed(2)) + "% ")]), _c('span', [_vm._v(" on top of the base 0.25% referral rewards.")])])])]) : _vm._e()], 1), _vm._m(10)])])])]), _vm._m(11)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature mb-5"
  }, [_c('span', [_vm._v("Earn passively")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field mt-2 has-text-center"
  }, [_c('b', [_vm._v("Select a coin and enter your address to get your referral code, you don't need to be actively mining!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-angle-down",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w400 mb-20"
  }, [_c('span', [_vm._v("If your setup doesn't accept the ")]), _c('span', {
    staticClass: "w600"
  }, [_vm._v("# ")]), _c('span', [_vm._v("symbol, you can try the alternative syntax, simply replace ")]), _c('span', {
    staticClass: "w600"
  }, [_vm._v("# ")]), _c('span', [_vm._v("with ")]), _c('span', {
    staticClass: "w600"
  }, [_vm._v("?ref=")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-helvetica mt-20"
  }, [_c('span', [_vm._v("All mining rewards are paid to your balance, ")]), _c('u', [_vm._v("whether you are mining or not")]), _c('span', [_vm._v(", and if you set a referral code for your own workers you also get rewarded with a lower mining fee.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "fs-16 mb-15"
  }, [_vm._v("Your benefits:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "ref-code-toggle"
  }, [_c('b', {
    staticClass: "fs-13"
  }, [_vm._v("...if someone else is actively using your referral code")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mt-10"
  }, [_c('span', [_vm._v("The platform fee is reduced to 0.5% and you earn 0.25% of his rewards, ")]), _c('u', [_vm._v(" passively")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-helvetica fs-16 has-text-left mb-18"
  }, [_c('b', [_vm._v("Are you a content creator?   ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-one-third"
  }, [_c('div', {
    staticClass: "mt-10"
  }, [_c('p', {
    staticClass: "fs-16 mb-10"
  }, [_vm._v("Get an easy to remember referral code to use with your social networks!")]), _c('p', {
    staticClass: "fs-14 mb-10"
  }, [_vm._v("Create content and share your referral code to your followers")]), _c('p', {
    staticClass: "fs-14 mb-10"
  }, [_vm._v("The more miners actively using your code the better rewards you get through our tiers!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-full"
  }, [_c('div', {
    staticClass: "fs-14 has-text-weight-bold mb-10 mt-10"
  }, [_vm._v("How do I get my Custom Referral Code?")]), _c('p', [_c('span', [_vm._v("Send an email to ")]), _c('b', [_vm._v("support@unmineable.com ")]), _c('span', [_vm._v("with the following information:")])]), _c('ul', {
    staticClass: "required-info"
  }, [_c('li', {
    staticClass: "mb-5"
  }, [_c('span', [_vm._v("A brief introduction of yourself and the kind of content that you elaborate")])]), _c('li', {
    staticClass: "mb-5"
  }, [_c('span', [_vm._v("The links to your social network accounts (TikTok, X, Twitch, Instagram, Facebook, etc). Your content doesn't have to be abount mining, as unMineable is a beginner oriented platform, we welcome users from everywhere.")])]), _c('li', {
    staticClass: "mb-5"
  }, [_c('span', [_vm._v("A suggestion of what your referral code should be (Remember that it could only have letters, numbers and a dash (-))")])]), _c('li', {
    staticClass: "mb-5"
  }, [_c('span', [_vm._v("The address and coin where you want to get your rewards! we will link your referral code to this address on the platform.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "feature feature-helvetica"
  }, [_c('div', {
    staticClass: "has-text-left fs-13"
  }, [_c('hr'), _c('b', [_vm._v("(*) ")]), _c('span', [_vm._v(" Referral codes are set at a worker level, so to have the best performance all of your referral's workers must be set with a referral code, referral rewards are given every time your referral gets rewarded for mining.")]), _c('b', [_vm._v("(**) ")]), _c('span', [_vm._v(" In the case of the fee reduction there is no need to have all of your workers set with a referral code, you just need one (valid code) set with an active miner for the reduction to be effective.")])]), _c('br'), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37fe1a92","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Referral.vue
// module id = 371
// module chunks = 1